<template>
  <div class="ct-checkbox-item"
       :class="{disabled}"
       @click.prevent="clickBox">
    <ct-icon :name="fontClass"
             :multi-color="true"></ct-icon>
    <input
      type="checkbox"
      class="ct-checkbox-iteminput"
      :disabled="disabled"
      :checked="value">
  </div>
</template>

<script>

export default {
  name: 'Checkbox',
  props: {
    label: String,
    disabled: Boolean,
    value: {
      default: false,
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      prefix: 'ct-checkbox'
    }
  },
  methods: {
    clickBox () {
      if (!this.disabled) { this.$emit('input', !this.value, {}) }
    }
  },
  computed: {
    fontClass () {
      return this.value
        ? this.disabled
          ? 'fxselecteddisabled'
          : 'fxselected'
        : this.disabled
          ? 'fxunselecteddisabled'
          : 'weigouxuan'
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
.ct-checkbox-item {
  box-sizing: border-box;
  * {
    box-sizing: border-box;
  }
  display: inline-block;
  height: 16px;
  line-height: 16px;
  font-size: 0;
  cursor: pointer;

  > svg {
    font-size: 14px;
    margin-right: 4px;

  }

  >.ct-checkbox-iteminput {
    display: none;
  }

  .ct-checkbox-label {
    display: inline-block;
    font-size: 14px;
  }

  &:hover {
    .ct-icon-weigouxuan {
      color: $primary;
    }
  }

  &.disabled {
    > svg {
      cursor: not-allowed;
    }
  }
}
</style>
